// extracted by mini-css-extract-plugin
export default {"user":"styles_user__QtrUD","edit":"styles_edit__qvtf-","delete":"styles_delete__sGnvt","table_container":"styles_table_container__RjwnS","userImage":"styles_userImage__0mewL"};